import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";
import { Provider } from "react-redux";
import store from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter basename={process.env.REACT_APP_HOME_PAGE}>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);
